import { ROLES } from '../../auth/constants';

const config = {
  SITE: 'quality',
  LABEL: 'Quality',
  SITE_ID: 'groups.coca-cola.com,18f2d0a2-e373-4c4a-b16f-64378e8812b8,8b771ee4-a7d7-460c-9a24-7ffcf9e10b58',
  PAGES_LIST_ID: 'e3ebc7ac-0798-4ca1-82fc-1fe77b512766',
  DOCUMENTS_LIST_ID: '2fbcea89-6532-4b67-a3b1-5dd153c92ed0',
  SITE_ASSETS_DRIVE_ID: 'b!otDyGHPjSkyxb2Q3jogSuOQed4vXpwxGmiR__PnhC1isZ3NJnA66Rp6xgI_efN2-',
  DOCUMENTS_DRIVE_ID: 'b!otDyGHPjSkyxb2Q3jogSuOQed4vXpwxGmiR__PnhC1iJ6rwvMmVnS6OxXdFTyS7Q',
  NEWS_TEMPLATE_ID: 'b66907ef-e433-452e-95a4-bebec8f02563',
  SETTINGS_FILE_PATH: 'Settings/HubSettings.json',
  OPT_OUT_FILE_PATH: 'Settings/EmailOptOut.txt',
  MANAGER_ROLES: [ROLES.QSE_MGR, ROLES.IM_MANAGER],
  VIVA_COMMUNITY_ID: undefined,
  libraryDrives: [
    {
      name: 'Quality Food Safety',
      label: 'Quality & Food Safety',
      driveId: 'b!otDyGHPjSkyxb2Q3jogSuOQed4vXpwxGmiR__PnhC1hGVuLIfCUUToWo8UC-lHwY',
      listId: 'c8e25646-257c-4e14-85a8-f140be947c18'
    },
    {
      name: 'Requirements',
      label: 'QFS Requirements',
      driveId: 'b!otDyGHPjSkyxb2Q3jogSuOQed4vXpwxGmiR__PnhC1jVnWkrdf-JQqI4y_cC250U',
      listId: '2b699dd5-ff75-4289-a238-cbf702db9d14'
    },
    {
      name: 'Supplier',
      label: 'Supplier Quality',
      driveId: 'b!otDyGHPjSkyxb2Q3jogSuOQed4vXpwxGmiR__PnhC1j4rIlsIxeIT7Rg-7-e0oXt',
      listId: '6c89acf8-1723-4f88-b460-fbbf9ed285ed'
    },
    {
      name: 'Destruction Facilities',
      label: 'Destruction Facilities',
      driveId: 'b!otDyGHPjSkyxb2Q3jogSuOQed4vXpwxGmiR__PnhC1gvD6hX_u7ETYu7DCk3ltEx',
      listId: '57a80f2f-eefe-4dc4-8bbb-0c293796d131'
    },
    {
      name: 'IMCR',
      label: 'Incident Management',
      driveId: 'b!otDyGHPjSkyxb2Q3jogSuOQed4vXpwxGmiR__PnhC1iAsNK3tdmIQonQ6wwUUBAD',
      listId: 'b7d2b080-d9b5-4288-89d0-eb0c14501003'
    },
    {
      name: 'Packaging',
      label: 'Packaging Guides',
      driveId: 'b!otDyGHPjSkyxb2Q3jogSuOQed4vXpwxGmiR__PnhC1jBni0QSgYDQ4cBDAzcgym8',
      listId: '102d9ec1-064a-4303-8701-0c0cdc8329bc'
    },
    {
      name: 'Pallet Patterns',
      label: 'Pallet Patterns',
      driveId: 'b!otDyGHPjSkyxb2Q3jogSuOQed4vXpwxGmiR__PnhC1irMCV8ly6cQrFFIgKcUB5F',
      listId: '7c2530ab-2e97-429c-b145-22029c501e45'
    }
  ]
}

export default config